import styled, { css } from "styled-components";

const SVGIconWrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  transform: ${props => `rotate(${props.rotation})`};
  ${props => {
    if (props.color || props.hoverColor) {
      return css`
        -webkit-mask-image: url(${props => props.src});
        -webkit-mask-size: cover;
        background-color: ${props => props.color ?? "white"};

        &:hover {
          background-color: ${props => props.hoverColor};
        }
      `;
    } else {
      return css`
        background-image: url(${props => props.src});
        background-repeat: no-repeat;
      `;
    }
  }};
`;

export { SVGIconWrapper };
